import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEntradaNfProductThunk } from '../../../slices/entradaProductSlice.js';
import Main from '../../../components/Main/Main.jsx';
import Title from '../../../components/Title.jsx';
import TableHistoricEntrada from '../../../components/Table/TableHistoricEntrada.jsx';
import InputSearch from '../../../components/Search/InputSearch.jsx';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import usePageTitle from '../../../hook/usePageTitle.js';
import { Button, Checkbox, Chip, Input, tab } from '@material-tailwind/react';
import TableUnicEntrada from '../../../components/Table/TableUnicEntrada.jsx';

const HistoricosEntradas = () => {
  usePageTitle();
  document.title = 'Historico | Entrada';

  const dispatch = useDispatch();
  const { nfFiscal, loading } = useSelector((state) => state.entrada);
  const [inputSearch, setInputSeacrh] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('historico');
  const location = useLocation();
  const navigate = useNavigate();
  const [unico, setUnico] = useState(false);

  const handleUnico = () => setUnico((prev) => !prev);

  const filtrados = nfFiscal.flatMap((nf) =>
    nf.produtos
      .filter((prod) => prod.produtoWinthor === search) // filtra pelo código
      .map((prod) => ({
        numeroPedido: nf.numeroPedido,
        idCompra: nf.idCompra,
        data_entrada: nf.data_entrada,
        valorTotal: nf.valorTotal,
        ...prod,
      }))
  );

  useEffect(() => {
    setInputSeacrh(search);
    console.log(search);
  }, [search]);

  const handleBuscaChange = useCallback((e) => {
    const value = e.target.value;
    const params = new URLSearchParams();
    params.set('historico', value);
    setSearchParams(params, {
      preventScrollReset: true,
    });
    navigate(`${location.pathname}?${params.toString()}`);
  }, []);

  const dadosFiltrado = nfFiscal.filter((nf) => {
    const search = inputSearch ? inputSearch.toLowerCase() : '';
    const filtro =
      // Pesquisa pelo id de compra,numeropedido,nome do produtos,codigo winthor
      nf.idCompra.toLowerCase().includes(search) ||
      nf.numeroPedido == search ||
      nf.produtos.some((item) => {
        return (
          item.produto.toLowerCase().includes(search) ||
          item.produtoWinthor.toLowerCase().includes(search)
        );
      });
    return filtro;
  });

  useEffect(() => {
    dispatch(getEntradaNfProductThunk());
  }, []);

  return (
    <Main>
      <div className="flex mt-0 justify-between">
        <Title>Ultimas Entradas</Title>
        <div className="flex justify-center items-center ">
          {unico && (
            <Button onClick={handleUnico} value="unico" color="red">
              unico
            </Button>
          )}
          {!unico && (
            <Button onClick={handleUnico} value="geral" className="dark:bg-white dark:text-black">
              GERAL
            </Button>
          )}
          <InputSearch search={handleBuscaChange} value={inputSearch} />
        </div>
      </div>
      <div className="h-[92%] shadow-darkShadow">
        {!unico && (
          <TableHistoricEntrada rows={dadosFiltrado} inputSearch={inputSearch} loading={loading} />
        )}

        {unico && <TableUnicEntrada rows={filtrados} inputSearch={inputSearch} loading={loading} />}
      </div>
      <Outlet />
    </Main>
  );
};

export default HistoricosEntradas;
